import React from "react";
import { Button, HStack, Icon } from "@chakra-ui/react";
import { FiChevronRight } from "react-icons/fi";

/**
 * Trailing cell of a clickable application row: the real "View" button is the keyboard / screen-reader path (the
 * row itself is mouse-only), named per application so button lists are unambiguous. Plus a chevron affordance.
 */
export const RowActions: React.FC<{ onView: () => void; applicationId: string | number }> = ({
  onView,
  applicationId,
}) => (
  <HStack justify="flex-end" spacing={2}>
    <Button
      variant="secondary"
      size="xs"
      aria-label={`View application ${applicationId}`}
      onClick={(event) => {
        event.stopPropagation();
        onView();
      }}
    >
      View
    </Button>
    <Icon
      as={FiChevronRight}
      boxSize="16px"
      color="sand.400"
      className="mbf-row-chevron"
      transition="transform 160ms cubic-bezier(0.2,0.8,0.2,1), color 160ms"
      aria-hidden
    />
  </HStack>
);

export const clickableRowStyles = {
  "&:hover .mbf-row-chevron": { transform: "translateX(2px)", color: "navy.900" },
};
